import React from "react";
import { Box, Typography, Divider, Grid } from "@mui/material";
import VideoReplace from "./VideoReplace";

interface VideoReviewProps {
  sections: {
    topic: string;
    question: string;
    questionId: number;
  }[];
  showEdit?: boolean
}


const VideoReview: React.FC<VideoReviewProps> = ({ sections, showEdit = false }) => {
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          backgroundColor: "#FFF2EE",
          color: "#FF2300",
          p: "10px 15px",
          borderRadius: 2,
        }}
      >
        <Box
          component="img"
          sx={{ width: 15, height: 15, mr: 1 }}
          src="/images/catalyst-profile/shield-star-line.png"
          alt="Shield Icon"
        />
        <Typography sx={{ fontSize: 13 }}>
            Your video will be seen on your dashboard after 12 hours.
        </Typography>
      </Box>

      <Box sx={{ mt: 2 }}>
        {sections.map((section, index) => (
          <React.Fragment key={index}>
            <Box sx={{ display: "flex", gap: 2 }} alignItems="center">
            <Grid container spacing={2} alignItems="center" >
            <Grid item xs={4} md={3} p={1}>
              <Box
                sx={{
                  position: "relative",
                  borderRadius: 2,
                  width: 100,
                  height: 60,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexShrink: 0,
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "#B7B3EB",
                    opacity: 0.3,
                    borderRadius: 2,
                    width: "100%",
                    height: "100%",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    zIndex: 1,
                  }}
                />
                <Box sx={{ position: "relative", zIndex: 2 }}>
                  <img src="/images/catalyst-profile/film-line.png" alt="Film Icon" />
                </Box>
              </Box>
              </Grid>
              <Grid item xs={5}>
              <Box sx={{ color: "#777777"}}>
                <Typography sx={{ fontSize: 14, fontWeight: 600 }}>{section.topic}</Typography>
                <Typography sx={{ fontSize: 12, opacity: 0.7 }}>{section.question}</Typography>
              </Box>
              </Grid>
              {showEdit && (
                <Grid item xs={3} sx={{ textAlign: "center" }}>
                  <VideoReplace questionId={section.questionId} />
                </Grid>
              )}
              </Grid>
            </Box>

            <Divider sx={{ my: 2, fontSize: 2, borderColor: "#B7B3EB" }} />
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );
};

export default VideoReview;
